import { useContext, useEffect, useState, useRef } from "react";
import henceforthApi from "../../../utils/henceforthApi";
import { Link } from "react-router-dom";
import Spinner from "../../../components/BootstrapCompo";
import { toast } from "react-toastify";
import { GlobalContext, handleError } from "../../../context/Provider";

const AddCategoryLevel2 = () => {
    const [subcategory, setCategory] = useState<any>({ data: [] });
    const [categoryId, setCategoryId] = useState("");
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [categoryError, setCategoryError] = useState("");
    const [nameError, setNameError] = useState("");
    const [imageError, setImageError] = useState("");
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const fileInputRef = useRef<HTMLInputElement>(null);
    const { authState } = useContext(GlobalContext);

    // 🔹 File Upload
    const fileUpload = async () => {
        try {
            const res = await henceforthApi.Common.do_spaces_file_upload("file", selectedFile);
            return res?.data?.file_name || "";
        } catch (error) {
            handleError(error);
            return "";
        }
    };

    // 🔹 File Change Handler
    const handleFileChange = (e: any) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!validTypes.includes(file.type)) {
            setImageError("Only JPG, JPEG, PNG allowed");
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            setImageError("Max size is 2MB");
            return;
        }

        setSelectedFile(file);
        setImageError("");
    };

    // 🔹 Submit
    const AddSubCategory = async (e: any) => {
        e.preventDefault();

        let hasError = false;

        if (!categoryId) {
            setCategoryError("Please select category");
            hasError = true;
        }

        if (!name) {
            setNameError("Please enter sub-category name");
            hasError = true;
        }

        if (hasError) return;

        setLoading(true);

        try {
            let image = "";

            if (selectedFile) {
                image = await fileUpload();
                if (!image) {
                    setLoading(false);
                    return;
                }
            }

            const data = {
                category_id: categoryId,
                name,
                ...(image && { image }),
                language: authState.lang,
            };

            const res = await henceforthApi.Category.addSubCategory(data);
            toast.success("Sub-Category added successfully");
            window.history.back();
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    // 🔹 Fetch Categories
    const initialiseCategory = async () => {
        try {
            const res = await henceforthApi.Category.listCategory();
            setCategory(res?.data || { data: [] });
        } catch {
            console.log("error fetching categories");
        }
    };

    useEffect(() => {
        initialiseCategory();
    }, [authState?.lang]);

    return (
        <>
            <section className="breadcrum-box">
                <div className="container-fluid">
                    <h2 className="fw-semibold">Add Sub Categories</h2>
                    <nav>
                        <ol className="breadcrumb m-0">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/category/level-2/1">Sub Categories</Link>
                            </li>
                            <li className="breadcrumb-item active fw-bold">
                                Add Sub Categories
                            </li>
                        </ol>
                    </nav>
                </div>
            </section>

            <div className="page-spacing">
                <section className="product-detail">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-md-5">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>Add Sub Categories</h5>
                                    </div>

                                    <div className="common-card-content">
                                        <form onSubmit={AddSubCategory}>

                                            {/* 🔹 Image Upload */}
                                            <div className="mb-4">
                                                <label className="fw-bold mb-2">
                                                    Sub-Category Image:
                                                </label>

                                                <div className="d-flex gap-3">
                                                    <div
                                                        onClick={() => fileInputRef.current?.click()}
                                                        style={{
                                                            width: "100px",
                                                            height: "100px",
                                                            border: "2px dashed #ccc",
                                                            borderRadius: "8px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            cursor: "pointer",
                                                            background: "#f8f9fa",
                                                        }}
                                                    >
                                                        {selectedFile ? (
                                                            <img
                                                                src={URL.createObjectURL(selectedFile)}
                                                                alt="preview"
                                                                onLoad={(e: any) =>
                                                                    URL.revokeObjectURL(e.target.src)
                                                                }
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "cover",
                                                                    borderRadius: "8px",
                                                                }}
                                                            />
                                                        ) : (
                                                            <span>Upload</span>
                                                        )}
                                                    </div>

                                                    <input
                                                        ref={fileInputRef}
                                                        type="file"
                                                        accept="image/png,image/jpeg,image/jpg"
                                                        style={{ display: "none" }}
                                                        onChange={handleFileChange}
                                                    />
                                                </div>

                                                <small>Only JPG/PNG, max 2MB</small>

                                                {imageError && (
                                                    <div className="invalid-feedback d-block">
                                                        {imageError}
                                                    </div>
                                                )}
                                            </div>

                                            {/* 🔹 Category Select */}
                                            <div className="mb-3">
                                                <label className="fw-bold">
                                                    Select Category
                                                </label>
                                                <select
                                                    className={`form-select ${categoryError ? "is-invalid" : ""}`}
                                                    value={categoryId}
                                                    onChange={(e) => {
                                                        setCategoryError("");
                                                        setCategoryId(e.target.value);
                                                    }}
                                                >
                                                    <option value="">Select</option>
                                                    {subcategory?.data.map((item: any) => (
                                                        <option key={item._id} value={item._id}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <div className="invalid-feedback">
                                                    {categoryError}
                                                </div>
                                            </div>

                                            {/* 🔹 Name */}
                                            <div className="mb-3">
                                                <label className="fw-bold">
                                                    Sub-Category Name:
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${nameError ? "is-invalid" : ""}`}
                                                    value={name}
                                                    maxLength={55}
                                                    onChange={(e) => {
                                                        setNameError("");
                                                        setName(e.target.value);
                                                    }}
                                                />
                                                <div className="invalid-feedback">
                                                    {nameError}
                                                </div>
                                            </div>

                                            {/* 🔹 Submit */}
                                            <button
                                                className="btn btn-theme w-100"
                                                disabled={loading}
                                            >
                                                {loading ? <Spinner /> : "Add Sub-Category"}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AddCategoryLevel2;